import VueRouter from 'vue-router'

const Home = () => import('../pages/home')
const BeforeCarShow = () => import('../pages/beforeCarShow/index')
const AfterCarShow = () => import('../pages/afterCarShow/index')
const Car = () => import('../pages/car/index')
const Brand = () => import('../pages/brand/index')
const Power = () => import('../pages/power/index')
const ContractUs = () => import('../pages/contractUs/index')
const LegalNotice = () => import('../pages/legalNotice/index')
const PrivacyPolicy = () => import('../pages/privacyPolicy/index')
const CookieSetting = () => import('../pages/cookieSetting/index')
const SocialMediaPrivacyPolicy = () => import('../pages/socialMediaPrivacyPolicy/index')
const InfoCollection = () => import('../pages/infoCollection/index')
const SubmitSuccessfully = () => import('../pages/submitSuccessfully/index')

const router = new VueRouter({
	mode: 'hash',
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/home',
			component: Home,
			name: 'Home'
		},
		{
			path: '/beforeCarShow',
			component: BeforeCarShow
		},
		{
			path: '/afterCarShow',
			component: AfterCarShow,
			name: 'AfterCarShow'
		},
		{
			path: '/car',
			component: Car,
			name: 'Car'

		},
		{
			path: '/brand',
			component: Brand,
			name: 'Brand'
		},
		{
			path: '/power',
			component: Power
		},
		{
			path: '/contactUs',
			component: ContractUs
		},
		{
			path: '/legalNotice',
			component: LegalNotice,
			name: 'LegalNotice'

		},
		{
			path: '/privacyPolicy',
			component: PrivacyPolicy,
			name: 'PrivacyPolicy'

		},
		{
			path: '/cookieSetting',
			component: CookieSetting,
			name: 'CookieSetting'

		},
		{
			path: '/socialMediaPrivacyPolicy',
			component: SocialMediaPrivacyPolicy,
			name: 'SocialMediaPrivacyPolicy'

		},
		{
			path: '/InfoCollection',
			component: InfoCollection,
			name: 'InfoCollection'
		},
		{
			path: '/SubmitSuccessfully',
			component: SubmitSuccessfully,
			name: 'SubmitSuccessfully'
		}
	]
})

export default router